module.exports = __webpack_public_path__ + "static/media/advertisement.2ba0561f.png";